import * as React from "react";
import { Context } from "./_context";
export const ReorientIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 4.754A7.317 7.317 0 0 1 19.246 11H22v2h-2.754A7.316 7.316 0 0 1 13 19.245V22h-2v-2.755A7.316 7.316 0 0 1 4.754 13H2v-2h2.754A7.317 7.317 0 0 1 11 4.754V2h2v2.754Zm-1 1.93a5.315 5.315 0 1 0 0 10.63 5.315 5.315 0 0 0 0-10.63ZM12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z", fill: "currentColor" }));
  return iconset[size];
};
ReorientIcon.iconId = "37kBaZ";
